<template>
  <div class="row">
    <div class="col-12">
      <MaterialInput
        id="input-name"
        v-model.trim="value.name"
        v-validate="'required|max:250'"
        :readonly="readonlyFormItem"
        type="text"
        class="city-form-group city-bg"
        name="name"
        :inputClasses="[{'is-invalid': fnHasError(`name`) }]"
        :error="fnFirstError(`name`)"
      >
        {{ $t(`${pageID}.model.name`) }}
      </MaterialInput>
    </div>
    <div class="col-6">
      <MaterialInput
        id="input-email"
        v-model.trim="value.email"
        v-validate="'emails'"
        :readonly="readonlyFormItem"
        type="text"
        class="city-form-group city-bg"
        name="email"
        :inputClasses="[{'is-invalid': fnHasError(`email`) }]"
        :error="fnFirstError(`email`)"
      >
        {{ $t(`${pageID}.model.email`) }}
      </MaterialInput>
    </div>
    <div class="col-6">
      <MaterialInput
        id="input-phone"
        v-model.trim="value.phone"
        v-validate="'numeric|min_value:1|min:9|max:14'"
        :readonly="readonlyFormItem"
        type="text"
        class="city-form-group city-bg"
        name="phone"
        :inputClasses="[{'is-invalid': fnHasError(`phone`) }]"
        :error="fnFirstError(`phone`)"
      >
        {{ $t(`${pageID}.model.phone`) }}
      </MaterialInput>
    </div>
    <div class="col-4">
      <MaterialSelect
        id="input-status"
        v-model.trim="value.status"
        v-validate="'required'"
        :disabled="readonlyFormItem"
        class="city-form-group city-bg"
        name="status"
        label="name"
        :filterable="true"
        :options="lists.onoff"
        :reduce="option => option.code"
        :inputClasses="[{'is-invalid': fnHasError('status') }]"
        :error=" fnFirstError('status')"
      >
        {{ $t(`${pageID}.model.status`) }}
      </MaterialSelect>
    </div>
  </div>
</template>
<script>
import mixin from '../../../../mixin';

export default {
    mixins: [mixin],
    inject: {
        parentValidator: 'parentValidator',
    },
    props: {
        vScope: {
            type: String,
            default: 'form'
        },
        value: {
            type: Object,
            default: () => {
                return {
                    name: null,
                    email: null,
                    phone: null,
                    status: 1,
                }
            },
        },
        propPageID: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            autoloadItem: false,
        }
    },
    created: function() {
        this.pageID = this.propPageID;
        this.$validator = this.parentValidator;
    },
}
</script>
